module.exports = __webpack_public_path__ + "static/img/11.d2cf6e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/11.png
// module id = Vx6x
// module chunks = 0